import React, { useState, useEffect, useCallback } from 'react';

import { Form, GroupItem, SimpleItem, ButtonItem } from 'devextreme-react/form';
import { ButtonType } from 'devextreme-react/common';

import GlobalLoader from '../loader/GlobalLoader';

import CustomerApi from '../../api/CustomerApi';

import CustomerInfosDto from '../../classes/dtos/accountmodule/CustomerInfosDto';

import './CustomerInfos.css';

interface CustomerInfosProps {
}

const CustomerInfos: React.FC<CustomerInfosProps> = () => {

    const [customerInfos, setCustomerInfos] = useState<CustomerInfosDto | null>(null);

    useEffect(() => {
        if (!customerInfos) {
            CustomerApi.GetCustomerInfosAsync().then((getCustomerInfosResult: any) => {
                if (getCustomerInfosResult.IsFailed()) {
                    // TODO: Handle failure case (e.g., logout)
                } else {
                    setCustomerInfos(getCustomerInfosResult.Result);
                }
            });
        }
    }, []);

    const handleSubmit = useCallback(async (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        CustomerApi.UpdateCustomerInfosAsync(customerInfos!).then((updateCustomerInfosResult: any) => {
            if (updateCustomerInfosResult.IsFailed()) {
                // TODO: Handle failure case (e.g., logout)
            }
        });
    }, [customerInfos]);

    const saveButtonOptions = {
        text: 'Save',
        type: 'default' as ButtonType,
        useSubmitBehavior: true,
        width: '120px',
    };

    const [cancelButtonOptions, setCancelButtonOptions] = useState({
        icon: 'Cancel',
        text: 'Cancel',
        width: '120px',
        onClick: () => {
            setCustomerInfos(null);
        },
    });

    if (!customerInfos) {
        return <GlobalLoader />
    }

    return (
        <div className={"block-card block-card--full-height"}>
            <div className={"BlockHeader-CustomerInfos"}>
                <h2>{"My company"}</h2>
            </div>
            <div style={{ width: '100%' }}>
                <form onSubmit={handleSubmit} >
                    <Form
                        colCount={1}
                        formData={customerInfos}
                        showColonAfterLabel={true}
                        height='calc(100vh - 400px)'>

                        <GroupItem colCount={2}>
                            <GroupItem caption="General informations" >
                                <SimpleItem dataField="Name"
                                    editorType="dxTextBox"
                                    validationRules={[
                                        { type: "required", message: "This field is required." } ]} />
                            </GroupItem>
                            <GroupItem caption="Meta API" >
                                <SimpleItem dataField="CustomerFragment"
                                    name="Fragment"
                                    editorType="dxTextBox"
                                    validationRules={[
                                        { type: "required", message: "This field is required." },
                                        {
                                            type: "pattern",
                                            pattern: /^[a-z0-9_-]+$/,
                                            message: "Only lowercase letters, numbers, hyphens, and underscores are allowed."
                                        } ]} />
                            </GroupItem>
                        </GroupItem>
                        <GroupItem >
                            <div style={{ flexGrow: 1, height: 'calc(100vh - 650px)' }}></div>
                        </GroupItem>
                        <GroupItem cssClass="last-group">
                            <GroupItem cssClass="buttons-group" colCount={2}>
                                <ButtonItem buttonOptions={cancelButtonOptions} />
                                <ButtonItem buttonOptions={saveButtonOptions} />
                            </GroupItem>
                        </GroupItem>
                    </Form>
                </form>
            </div>
        </div>
    );
};

export default CustomerInfos;
